import { update } from '@/common/utils/updateApp'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['loginConfig', 'userInfo', 'loginNotices']),
    ...mapState({
      authorizationPnosMap: state => state.app.authorizationPnosMap,
    })
  },
  data: function () {
    return {
      homeType: '1'
    }
  },
  created () {
    this.getLoginNotice(0)
    this.getBadgeCount()
  },
  mounted () {
    update() //app 更新
  },
  methods: {
    ...mapActions(['getLoginNotice', 'getBadgeCount', 'getAuthorizationPnos']),
    /**
	 * 传入一维菜单数组，根据每个元素的PRO_TYPE属性 和 authorizationPnosMap比较
	 * authorization没有开通的，元素添加openDiasble: true,
	 * 元素没有PRO_TYPE属性的不做处理
	 * @param {Array} menus 一维菜单数组
	 */
    genMenu (menus) {
      const OPEN_PRO_TYPES = this.authorizationPnosMap.map(i => Number(i.productNo))
      menus.forEach(menu => {
        if (menu.PRO_TYPE && OPEN_PRO_TYPES.includes(menu.PRO_TYPE)) {
          menu.openDiasble = true
        }
      })
    },
    to (item) {
      if (!item.openDiasble) {
        this.$toast('功能已关闭！如要启用，请联系服务商开通！')
      } else {
        this.$router.push({ path: item.link })
      }
    },
  }
}
